<template>
  <div class="wx-login">
    Loading...{{ time }}秒后自动跳转
    {{ authcode }}
  </div>
</template>

<script>
import { getCleanerInfo, loginByCode } from '../api/lxz/cleaner'
import { Notify } from 'vant'

export default {
  name: 'WxLogin',
  data() {
    return {
      loading: false,
      authcode: '',
      time: 5,
      timer: null
    }
  },
  async mounted() {

  },
  async beforeDestroy() {
    clearInterval(this.timer)
  },
  async created() {
    const accessToken = localStorage.getItem('lxz-token')
    let isLogin = false
    if (accessToken) {
        // 如果有token直接登录
      await getCleanerInfo({}, { isPrompt: true }).then(res => {
        if (res && res.status === 200) {
          isLogin = true
          this.$router.push('/cleanerPage/home')
        }
      }).catch(err => {
        console.log('err', err)
      })
    }

    if (isLogin) return

    // 获取code参数
    const code = this.$route.query.code
    if (code) {
      sessionStorage.setItem('code', code)
      this.authcode = code
      await loginByCode({ code }).then(res => {
        const ok = res.status === 200
        const token = res.data.token || ''
        console.log('login by code', token, res.data)
        if (!ok || !token) {
          // Notify({ message: (res && res.message) || '登录失败', type: 'danger' })
          this.$router.push('/login')
          return
        }
        localStorage.setItem('lxz-token', token)
        Notify({ message: '登录成功', type: 'success' })
        this.$router.replace('/cleanerPage/home')
      }).catch(err => {
        // this.$router.push('/login')
        console.log('err', err)
      })
    } else {

      this.timer = setInterval(() => {
        this.time--
        if (this.time <= 0) {
          clearInterval(this.timer)
          let url = window.encodeURIComponent('https://cleaner-task.longxiaozhu.com/wx')
          window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0c1d3c5027b903b5&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=bindandlogin#wechat_redirect`)
        }
      }, 1000)

    }
  }
}
</script>